import { component } from 'picoapp'
import { zelektor } from '@/lib/utility-functions.js'

export default component(node => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { login, recover, recoverOpen, recoverCancel, recoverSuccess } = zelektor(node)
    const recoverIsTarget = window.location.hash.match(/\#recover/) ? true : false


    /*******************************************************************************************************************************************/
    /* Initialize
    /*******************************************************************************************************************************************/
    recoverIsTarget || recoverSuccess ? openRecover() : closeRecover()

    
    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    recoverOpen.addEventListener('click', (e) => {
        e.preventDefault()
        openRecover()
    })

    recoverCancel.addEventListener('click', (e) => {
        e.preventDefault()
        closeRecover()
    })


    /*******************************************************************************************************************************************/
    /* Open Recover
    /*******************************************************************************************************************************************/
    function openRecover() {
        login.style.display = 'none'
        recover.style.display = ''
    }


    /*******************************************************************************************************************************************/
    /* Close Recover
    /*******************************************************************************************************************************************/
    function closeRecover() {
        login.style.display = ''
        recover.style.display = 'none'

        // clear "#recover" from url to prevent reload confusion
        history.pushState("", document.title, window.location.pathname + window.location.search);
        
        // remove all errors
        recover.querySelectorAll('.js-formError').forEach(error => {
          error.remove()
        })
    }
})